import React, { useState } from 'react';
import { Container, Row, Col, Card, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom'

const Footer = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  const handleClickScroll = () => {
    const element = document.getElementById('header');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  // Websites Navbar, displays routes defined in 'src/data/routes'
  return (
    <section className='section-box footer-box' id="contact">
      <Container>
        <Row className='mb-5'>
          <Col lg="12" xl="3" className='mb-5 mb-xl-0'>
            <h2 className='mb-4'>Let’s create extraordinary together</h2>
            <div className='d-flex align-items-center flex-wrap'>
              <p className='mb-0 me-4'>Based in India</p>
              <Link to="https://www.linkedin.com/in/bavadiya/" target='_blank' className='mx-2'>
                <span className='visually-hidden-focusable'>linkedin</span>
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.80527 17H0.280804V5.64997H3.80527V17ZM2.04114 4.10172C0.914129 4.10172 0 3.16822 0 2.04118C8.06665e-09 1.49983 0.215048 0.980645 0.597836 0.597849C0.980623 0.215053 1.49979 0 2.04114 0C2.58248 0 3.10165 0.215053 3.48444 0.597849C3.86723 0.980645 4.08228 1.49983 4.08228 2.04118C4.08228 3.16822 3.16777 4.10172 2.04114 4.10172ZM16.9962 17H13.4793V11.4749C13.4793 10.1581 13.4528 8.46945 11.6469 8.46945C9.81446 8.46945 9.53366 9.90006 9.53366 11.38V17H6.01299V5.64997H9.39326V7.19822H9.44259C9.91313 6.30646 11.0625 5.36537 12.7773 5.36537C16.3443 5.36537 17 7.7143 17 10.7653V17H16.9962Z" fill="white" />
                </svg>
              </Link>
              <Link to="https://github.com/vishalbavadiya" target='_blank' className='mx-2'>
                <span className='visually-hidden-focusable'>Github</span>
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.68609 13.6884C5.68609 13.7587 5.60726 13.8149 5.50786 13.8149C5.39476 13.8255 5.31593 13.7692 5.31593 13.6884C5.31593 13.6181 5.39476 13.5618 5.49415 13.5618C5.59698 13.5513 5.68609 13.6075 5.68609 13.6884ZM4.62016 13.5302C4.59617 13.6005 4.66472 13.6813 4.76754 13.7024C4.85665 13.7376 4.95948 13.7024 4.98004 13.6321C5.00061 13.5618 4.93548 13.481 4.83266 13.4493C4.74355 13.4247 4.64415 13.4599 4.62016 13.5302ZM6.13508 13.4704C6.03569 13.495 5.96714 13.5618 5.97742 13.6427C5.9877 13.713 6.07681 13.7587 6.17964 13.7341C6.27903 13.7095 6.34758 13.6427 6.3373 13.5724C6.32702 13.5056 6.23448 13.4599 6.13508 13.4704ZM8.39032 0C3.63649 0 0 3.70156 0 8.5772C0 12.4756 2.39234 15.8116 5.80948 16.9857C6.24819 17.0665 6.40242 16.7888 6.40242 16.5603C6.40242 16.3424 6.39214 15.1402 6.39214 14.402C6.39214 14.402 3.99294 14.9293 3.48911 13.3544C3.48911 13.3544 3.09839 12.3315 2.53629 12.0678C2.53629 12.0678 1.75141 11.516 2.59113 11.5265C2.59113 11.5265 3.44456 11.5968 3.91411 12.4334C4.66472 13.7903 5.92258 13.4001 6.4127 13.1681C6.49153 12.6057 6.71431 12.2155 6.96109 11.9835C5.04516 11.7655 3.1121 11.4808 3.1121 8.09913C3.1121 7.13244 3.37258 6.64733 3.92097 6.02865C3.83186 5.80016 3.54052 4.85807 4.01008 3.6418C4.72641 3.41331 6.375 4.59091 6.375 4.59091C7.06048 4.39406 7.79738 4.29212 8.52742 4.29212C9.25746 4.29212 9.99436 4.39406 10.6798 4.59091C10.6798 4.59091 12.3284 3.40979 13.0448 3.6418C13.5143 4.86159 13.223 5.80016 13.1339 6.02865C13.6823 6.65085 14.0181 7.13595 14.0181 8.09913C14.0181 11.4913 11.9994 11.762 10.0835 11.9835C10.3988 12.2612 10.6661 12.7885 10.6661 13.6146C10.6661 14.7992 10.6558 16.2651 10.6558 16.5533C10.6558 16.7818 10.8135 17.0595 11.2488 16.9786C14.6762 15.8116 17 12.4756 17 8.5772C17 3.70156 13.1442 0 8.39032 0ZM3.33145 12.1241C3.2869 12.1592 3.29718 12.2401 3.35544 12.3069C3.41028 12.3631 3.48911 12.3877 3.53367 12.342C3.57823 12.3069 3.56794 12.226 3.50968 12.1592C3.45484 12.103 3.37601 12.0784 3.33145 12.1241ZM2.96129 11.8394C2.9373 11.8851 2.97157 11.9413 3.04012 11.9764C3.09496 12.0116 3.16351 12.0011 3.1875 11.9518C3.21149 11.9061 3.17722 11.8499 3.10867 11.8147C3.04012 11.7937 2.98528 11.8042 2.96129 11.8394ZM4.07177 13.0908C4.01694 13.1365 4.0375 13.2419 4.11633 13.3087C4.19516 13.3896 4.29456 13.4001 4.33911 13.3439C4.38367 13.2982 4.3631 13.1927 4.29456 13.1259C4.21915 13.0451 4.11633 13.0345 4.07177 13.0908ZM3.68105 12.574C3.62621 12.6092 3.62621 12.7006 3.68105 12.7814C3.73589 12.8623 3.82843 12.8974 3.87298 12.8623C3.92782 12.8166 3.92782 12.7252 3.87298 12.6443C3.825 12.5635 3.73589 12.5283 3.68105 12.574Z" fill="white" />
                </svg>
              </Link>
              <Link to="https://www.upwork.com/freelancers/bavadiyavishal" target='_blank' className='mx-2'>
                <span className='visually-hidden-focusable'>Upwork</span>
                <svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.8332 10.1752C18.7115 10.1752 17.311 8.5107 16.9188 7.86886C17.4207 3.79109 18.8928 2.50315 20.8332 2.50315C22.7524 2.50315 24.2456 4.06066 24.2456 6.3413C24.2456 8.62195 22.7524 10.1795 20.8332 10.1795V10.1752ZM20.8332 0C17.3785 0 15.4424 2.28492 14.8856 4.63831C14.2571 3.44022 13.7932 1.83564 13.4304 0.34659H8.65552V6.37981C8.65552 8.56632 7.67271 10.188 5.75348 10.188C3.83424 10.188 2.73332 8.5706 2.73332 6.37981L2.75441 0.34659H0V6.37981C0 8.13843 0.561006 9.73446 1.586 10.8769C2.64052 12.0536 4.08311 12.6655 5.75348 12.6655C9.07733 12.6655 11.3973 10.081 11.3973 6.37981V2.32343C11.7432 3.65844 12.5699 6.22149 14.1517 8.46791L12.6754 17H15.4762L16.4506 10.9539C16.7711 11.2235 17.1128 11.4674 17.4713 11.6813C18.4077 12.2804 19.4834 12.6184 20.5885 12.6569C20.5885 12.6569 20.7572 12.6655 20.8458 12.6655C24.2709 12.6655 27 9.97407 27 6.3413C27 2.70853 24.2667 0.00427898 20.8416 0.00427898L20.8332 0Z" fill="white" />
                </svg>
              </Link>
            </div>
          </Col>
          <Col lg="12" xl="9">
            <Row>
              <Col lg="6" className='mb-4 mb-lg-0'>
                <Card className='py-5 mb-0'>
                  <Card.Body className='px-5 py-0'>
                    <Card.Text className='mb-4'>
                      Looking for a Front-End Developer?
                    </Card.Text>
                    <Card.Title className='mb-0'>
                      <Link to="https://www.upwork.com/freelancers/bavadiyavishal" target='_blank' className=''>
                        Hire Me
                      </Link>
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg="6">
                <Card className='py-5 mb-0'>
                  <Card.Body className='px-5 py-0'>
                    <Card.Text className='mb-4'>
                      Want to contact me?
                    </Card.Text>
                    <Card.Title className='mb-0'>
                      <Link onClick={handleShow}>
                        Contact Me
                      </Link>
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className='mb-3'>
          <Col lg="12">
            <h3 className='display-1'><span>V</span>ishal <span>B</span>avadiya</h3>
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col lg="12">
            <hr />
          </Col>
        </Row>
        <Row>
          <Col lg="6" className='text-center text-lg-start mb-3 mb-lg-0'>
            ©2024 Vishal Bavadiya, All Rights Reserved
          </Col>
          <Col lg="6" className='text-center text-lg-end'>
            <Link onClick={handleClickScroll}>
              Back to Top
            </Link>

          </Col>
        </Row>
      </Container>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Contact Me</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            title="Contact Form"
            src="https://docs.google.com/forms/d/e/1FAIpQLSdsQpsQGEBDLUdbfQ1jv4GDjJLiU5cNNmeLNdqRA0ACIe9_lA/viewform?embedded=true"
            width="100%"
            height="600"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >
            Loading...
          </iframe>
        </Modal.Body>
      </Modal>      
      <div className='mobile-menu d-md-none'>
        <Container>
          <Row>
            <Col className='text-center px-2'>
              <p className='mb-1'>Ready to work with me?</p>
              <div className='d-flex justify-content-center'>
                <Link className='btn btn-outline-primary btn-sm mx-2' to="https://www.upwork.com/freelancers/bavadiyavishal" target="_blank">Hire Me</Link>
                <Link className='btn btn-outline-primary btn-sm mx-2' to="/get-free-quote">Get Free Quote</Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};
export default Footer;
